export default "__VITE_PUBLIC_ASSET__24044589__"